export default __webpack_public_path__ + "static/media/mb7.93a20607.jpg";